import Litepicker from "litepicker";
import "litepicker/dist/plugins/mobilefriendly";

export const DatePickerHook = {
  mounted() {
    renderDatePicker(this.el);
  },
};

function renderDatePicker(el) {
  const picker = new Litepicker({
    element: el,
    lang: "fr-FR",
    format: "DD/MM/YYYY",
    minDate: el.dataset.minDate,
    maxDate: el.dataset.maxDate,
    resetButton: el.dataset.resetButton === "on",
    singleMode: el.dataset.rangeKind === "single",
    elementEnd: document.getElementById(el.dataset.elementEndId),
    tooltipText: { one: "jour", other: "jours" },
    plugins: litepickerPlugins(el.dataset.deviceKind),
  });

  picker.on("selected", (date, endDate) => {
    if (date && endDate) {
      const startHidden = document.getElementById(el.dataset.elementStartHiddenId);
      const endHidden = document.getElementById(el.dataset.elementEndHiddenId);
      startHidden.value = formatDateForElixir(date);
      endHidden.value = formatDateForElixir(endDate);
      dispatchEvent(endHidden, "change");
    } else if (date) {
      const hidden = document.getElementById(el.dataset.elementHiddenId);
      hidden.value = formatDateForElixir(date);
      dispatchEvent(hidden, "change");
    } else {
      let el_exists = false;
      for (const id in [
        el.dataset.elementEndHiddenId,
        el.dataset.elementHiddenId,
        el.dataset.elementStartHiddenId,
      ]) {
        const e = document.getElementById(id);
        if (e) {
          e.value = null;
          el_exists = e;
        }
      }
      if (el_exists) {
        dispatchEvent(el_exists, "change");
      }
    }
  });

  picker.on("clear:selection", () => {
    const hiddenInput = document.getElementById(el.dataset.elementHiddenId);
    hiddenInput.value = null;
    dispatchEvent(hiddenInput, "change");
  });
}

function formatDateForElixir(date) {
  const new_date = date.toJSDate();
  const offset = new_date.getTimezoneOffset();
  const date_with_offset = new Date(new_date.getTime() - offset * 60 * 1000);
  return date_with_offset.toISOString().split("T")[0];
}

function dispatchEvent(el, name) {
  el.dispatchEvent(new Event(name, { bubbles: true }));
}

function litepickerPlugins(deviceKind) {
  if (deviceKind === "mobile") {
    return ["mobilefriendly"];
  }
  return [];
}
